import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import NumberInput from 'components/common/NumberInput'
import { bufferAroundPoint } from 'constants.js'
import PaneHeader from '../panes/PaneHeader'

const BulkPointBufferPane = ({ bulkBuffer, group, uiStore, dataStore, selectionStore, t }) => {
  useEffect(() => {
    const map = uiStore && uiStore.map && uiStore.map.leafletElement
    const center = map && typeof map.getCenter === 'function' ? map.getCenter() : null
    const zoom = map && typeof map.getZoom === 'function' ? map.getZoom() : null
    if (uiStore && typeof uiStore.suppressMapBoundsTemporarily === 'function') {
      uiStore.suppressMapBoundsTemporarily(500)
    }
    const timer = setTimeout(() => {
      if (map && center && zoom != null) {
        map.setView(center, zoom, { animate: false })
      }
    }, 0)
    return () => clearTimeout(timer)
  }, [])

  const handleSubmit = async () => {
    uiStore.setProcessing(true)

    const currentYear = dataStore.defaultYear.result
    const currentDataset = dataStore.defaultDsName

    const result = await bulkBuffer.add(group.pk || group.id, currentYear, currentDataset)
    if (result) {
      await group.loadGeometries()
      selectionStore.clear()
      uiStore.setProcessing(false)
    } else {
      uiStore.setProcessing(false)
    }
  }

  const handleCancel = () => {
    selectionStore.clear()
  }

  return (
    <div className='line-pane bulk-buffer-pane'>
      <PaneHeader
        icon={bufferAroundPoint}
        title={t('ITEM.BULK_BUFFER_TITLE', { defaultValue: 'Batch Point Buffers' })}
        onClose={handleCancel}
      />

      <p className='text-regular bulk-pane-description' style={{ marginBottom: '14px', fontSize: '13px', color: '#64748B' }}>
        {t('ITEM.BULK_BUFFER_DESC')}
      </p>

      <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
        <section className='spaced-children bulk-pane-form-section'>
          <label>
            <span>{t('GLOBAL.RADIUS_KM', { defaultValue: 'Radius (km)' })}</span>
            <div className='input-with-unit'>
              <NumberInput
                min={1}
                value={bulkBuffer.radius}
                inputValue={bulkBuffer.radius}
                onChange={value => (bulkBuffer.radius = value)}
              />
              <span className='input-with-unit__unit'>
                {t('GLOBAL.KM', { defaultValue: 'km' })}
              </span>
            </div>
            <span className='invalid'>{bulkBuffer.invalid.get('radius')}</span>
          </label>
        </section>
        <section>
          <div className='centered-button-row'>
            <button type='button' onClick={handleCancel}>
              <span>{t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}</span>
            </button>
            <button type='submit' className='full-btn'>
              <span>{t('GLOBAL.CONFIRM_ADD', { defaultValue: 'Create buffers' })}</span>
            </button>
          </div>
        </section>
      </form>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore', 'selectionStore')(observer(BulkPointBufferPane)))
